import { equals, update } from 'ramda';
import { useState, useMemo, useCallback, useEffect } from 'react';
import { parseJson } from '../utils/parseJson';
import { SortType } from '../api/generated';
const sortingQueryParam = 'sorting';
export const useSorting = (setQueryParam, getQueryParam, defaultSorting) => {
    const queryParamValue = parseJson(getQueryParam(sortingQueryParam));
    const [sorting, setSorting] = useState(queryParamValue ?? defaultSorting ?? []);
    const isDefaultSorting = useMemo(() => {
        if (!defaultSorting)
            return sorting.length === 0;
        return equals(sorting, defaultSorting);
    }, [sorting, defaultSorting]);
    const toggleSorting = useCallback((fieldName) => {
        setSorting((oldSorting) => {
            const existingSortingIndex = oldSorting.findIndex((s) => s.fieldName === fieldName);
            if (existingSortingIndex === -1) {
                return [...oldSorting, { fieldName, direction: 'ASC' }];
            }
            const existingSorting = oldSorting[existingSortingIndex];
            if (existingSorting.direction === 'ASC') {
                return update(existingSortingIndex, { fieldName, direction: SortType.Desc }, oldSorting);
            }
            return update(existingSortingIndex, { fieldName, direction: SortType.Asc }, oldSorting);
        });
    }, []);
    const setColumnSorting = useCallback((fieldName, direction) => {
        setSorting((oldSorting) => {
            const existingSortingIndex = oldSorting.findIndex((s) => s.fieldName === fieldName);
            if (existingSortingIndex === -1) {
                return [...oldSorting, { fieldName, direction }];
            }
            return update(existingSortingIndex, { fieldName, direction }, oldSorting);
        });
    }, []);
    const removeColumnSorting = useCallback((fieldName) => {
        setSorting((oldSorting) => {
            const nextSorting = oldSorting.filter((s) => s.fieldName !== fieldName);
            const isSortingEmpty = nextSorting.length === 0;
            if (isSortingEmpty && defaultSorting)
                return defaultSorting;
            return nextSorting;
        });
    }, [defaultSorting]);
    const setAsOnlySorting = useCallback((fieldName, direction) => {
        setSorting([{ fieldName, direction }]);
    }, []);
    const clearSorting = useCallback(() => setSorting(defaultSorting ?? []), [defaultSorting]);
    useEffect(() => {
        setQueryParam(sortingQueryParam, JSON.stringify(sorting));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sorting]);
    return {
        isDefaultSorting,
        sorting,
        toggleSorting,
        setColumnSorting,
        setAsOnlySorting,
        removeColumnSorting,
        clearSorting,
    };
};
//# sourceMappingURL=useSorting.js.map